module.exports = __webpack_public_path__ + "media/circlecircle.0b932cf2.mp3";